import { ENDPOINTS } from "./enpoints";
import { createAPIEndpoint } from "./authenticated.requests";
export const APi = {
  ENDPOINTS,
  createAPIEndpoint,
};
